module.exports = __webpack_public_path__ + "img/imgexchangebt.ccc8dda9.png";